{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Šablonai",
    "DESCRIPTION": "Peržiūrėkite pranešimų šablonus, sinchronizuotus iš jūsų WhatsApp gautų laiškų aplankų. Norėdami sukurti ar redaguoti šabloną, tvarkykite jį pas savo teikėją.",
    "COUNT": "Šablonų: {n}",
    "LEARN_MORE": "Sužinoti daugiau apie WhatsApp šablonus",
    "SYNC_TEMPLATES": "Sinchronizuoti šablonus",
    "SYNC_SUCCESS": "Šablonų sinchronizavimas pradėtas visuose WhatsApp gautų laiškų aplankuose. Atnaujinimai gali užtrukti kelias minutes.",
    "PARTIAL_SYNC_ERROR": "Šablonų sinchronizavimas pradėtas kai kuriuose WhatsApp gautų laiškų aplankuose, tačiau kitų sinchronizuoti nepavyko.",
    "SYNC_ERROR": "Nepavyko pradėti šablonų sinchronizavimo. Bandykite dar kartą.",
    "SEARCH_PLACEHOLDER": "Ieškoti pagal turinį arba pavadinimą...",
    "MANAGE_IN_META": "Tvarkyti Meta",
    "LOADING": "Įkeliami WhatsApp šablonai...",
    "EMPTY": "WhatsApp šablonų nerasta.",
    "NO_RESULTS": "Nė vienas šablonas neatitinka jūsų filtrų.",
    "FETCH_ERROR": "Nepavyko įkelti WhatsApp šablonų. Bandykite dar kartą.",
    "PARTIAL_FETCH_ERROR": "Kai kurių WhatsApp šablonų nepavyko įkelti. Bandykite dar kartą.",
    "LAST_SYNC_ATTEMPT": "Paskutinis sinchronizavimo bandymas {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Nepateikta WhatsApp patvirtinimui"
    },
    "FILTERS": {
      "ALL_INBOXES": "Visi gautų laiškų aplankai",
      "ALL_LANGUAGES": "Visos kalbos",
      "ALL_TYPES": "Visi tipai"
    },
    "TYPES": {
      "TEXT": "Tekstas",
      "IMAGE": "Paveikslėlis",
      "VIDEO": "Video",
      "DOCUMENT": "Dokumentas",
      "CALL_TO_ACTION": "Raginimas veikti",
      "COPY_CODE": "Kopijuoti kodą"
    },
    "PREVIEW": {
      "TITLE": "Šablono peržiūra",
      "DESCRIPTION": "Peržiūrėkite, kaip šis šablonas atrodo WhatsApp.",
      "OPEN": "Peržiūrėti {name}",
      "CLOSE": "Uždaryti peržiūrą",
      "DETAILS": "Šablono informacija",
      "STATUS": "Būsena",
      "TYPE": "Turinio tipas",
      "CATEGORY": "Kategorija",
      "LANGUAGE": "Kalba",
      "INBOXES": "Gautų laiškų aplankai"
    }
  }
}
